<template>
  <basiCcontainer class="real-message-box">
    <template #head>
      <Banner></Banner>
      <!-- <div class="head-parent" >
        <div class="left" v-if="projectObj && projectObj[0]">
          <span class="left-t" @click="$router.go(-1)">{{projectObj[0].txt}}/</span>
          <span>项目通知</span>
        </div>
        <div class="left" v-else>
           <span>通知中心</span>
        </div>
      </div> -->
      <!-- <div class="filter">
        <Date @change="changeTime" v-model="timeArr"></Date>
        <Opation v-model="order_is_read" @change="changeOpation"></Opation>
        <RealBtn @click.native="readAll"></RealBtn>
      </div> -->
    </template>
    <div class="real-message">
      <Tree @change="change" :numberCount="numberCount" ref="tree" :selectId="selectId"></Tree>
      <div class="real-message-in">
        <Content ref="content" :message_type="message_type" :message_label="message_label" :project_id="project_id" :cross_project_id="cross_project_id" :order_is_read="order_is_read" @reset="reset" @changeTime="changeTime"></Content>
      </div>
    </div>
  </basiCcontainer>
</template>

<script>
import Tree from './tree'
import Content from './content'
import api from '@/services/api/realMessage/realMessage'
import { mapState, mapMutations } from 'vuex';
import Banner from '@/components/banner'
// import Date from '@/components/taskFilterBox/date'
// import RealBtn from './filterBox/realBtn'
// import Opation from './filterBox/opation'
import bus from '@/bus'
export default {
  components: {
    Tree,
    Content,
    Banner
    // RealBtn,
    // Opation,
    // Date,
  },
  data() {
    return {
      message_type: 0,
      message_label: '全部通知',
      project_id: '',
      cross_project_id: '',
      start_time: '',
      end_time: '',
      numberCount: {},
      order_is_read: 1,
      timeArr: [],
      selectId: ''
    }
  },
  watch: {
    '$route.query':{
      handler() {
        this.init()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    bus.$on('taskClose', () => {
      this.reset()
      this.$refs.content ? this.$refs.content.reset() : ''
    })
  },
  beforeDestroy() {
    bus.$off('taskClose')
  },
  methods: {
    init() {
      this.project_id = this.$route.query.project_id || ''
      this.cross_project_id = this.$route.query.cross_project_id || ''
      this.selectId = this.$route.query.id
      this.$nextTick(() => {
        this.$refs.tree ? this.$refs.tree.treeCheck(this.selectId) : ''
        this.reset()
      })
      this.$refs.content ? this.$refs.content.reset() : ''
    },
    change(val,label) {
      this.message_type = val
      this.message_label = label
    },
    reset() {
      this.getMessageNum()
    },
    changeTime(val) {
      this.start_time = val[0]
      this.end_time = val[1]
      this.reset()
    },
    changeOpation(val) {
      this.$nextTick(() => {
        this.$refs.content.changeOpation(val)
        this.reset()
      })
    },
    readAll() {
      this.$refs.content.readAll()
      this.$nextTick(() => {
        this.reset()
      })
    },
    async getMessageNum() {
      let params = {
        start_time: this.start_time,
        end_time: this.end_time,
        project_id: this.project_id,
        cross_project_id: this.cross_project_id
      }
      let result = await api.getNumberOfUnreadMessages(params)
      this.numberCount = result
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.real-message-box {
  position: relative;
  height: 100%;
  width: 100%;
  .search-box {
    display: flex;
    align-items: center;
    padding: 0 32px;
    justify-content: space-between;
    padding-left: 0;
    .left {
      display: flex;
      align-items: center;
      span {
        font-size: 18px;
        font-weight: 500;
      }
      .left-t {
        color: rgba(32, 32, 32, 0.6);
        margin-right: 4px;
        cursor: pointer;
        &:hover {
          @include fontColorOpacity(1);
        }
        &:active {
          @include fontColorOpacity(.6);
        }
      }
    }
    .filter {
      display: flex;
      align-items: center;
      &> div{
        margin-left: 8px;
      }
    }
  }
}
.real-message {
  width: 100%;
  height: 100%;
  display: flex;
  .head {
    height: 54px;
    padding: 0 32px;
  }
  .real-message-in {
    display: flex;
    justify-content: center;
    flex: 1;
    width: 0;
  }
}
</style>
